// Ren logik (ingen DOM) for højreklikreglen i digitaliseringssystemet:
//
//   Er et værktøj aktivt, men er der ikke en operation i gang, skal et ALMINDELIGT højreklik forlade værktøjet
//   (semantisk som ESC).
//
// "Almindeligt" betyder: ikke Shift (menuer), ikke Ctrl (box-selection/pause) og ikke et højre-TRÆK (pan med højre
// knap, som OrbitControls bruger) - dvs. musen er næsten ikke flyttet mellem mousedown og mouseup. InputHandler
// nulstiller sin egen drag-state i sin mouseup, FØR værktøjernes handlere kører, så bevægelsen måles her fra
// mousedown-positionen i stedet.
//
// Selve "er en operation i gang"-signalet ejes af DigitizationModule (isOperationActive()); capture-primitiverne
// rapporterer til det ved første brugerhandling (_markOperationStarted()), og startInsertion()/stopInsertion()/
// cancelActiveTool() nulstiller det.

// Chromes egen klik-tolerance er et par px; 4 px dækker en let rystende hånd uden at et reelt pan-træk tæller som klik.
export const RIGHT_CLICK_SLOP_PX = 4;

// down/up: {x, y} i klient-pixels (down kan være null, hvis mousedown ikke blev set på canvas'et).
export function isPlainRightClick({down, up, shiftKey = false, ctrlKey = false, ctrlHeld = false, slop = RIGHT_CLICK_SLOP_PX} = {}){
	if(!down || !up) return false;
	if(shiftKey || ctrlKey || ctrlHeld) return false;
	return Math.hypot(up.x - down.x, up.y - down.y) <= slop;
}

// Skal reglen forlade værktøjet nu?
export function shouldExitToolOnRightClick({activeTool, operationActive, plainRightClick} = {}){
	return !!activeTool && !operationActive && !!plainRightClick;
}
